import { FormattedMessage } from '@faceup/localization'
import { Typography } from '@faceup/ui-base'
import { sharedMessages } from '../../../Shared/translations'
import type { Recipient } from '../hooks/useRecipients'

type RecipientPopoverContentProps = {
  recipient: Pick<Recipient, 'name' | 'bio' | 'isPartner'>
  companyName: string | null
}

export const RecipientPopoverContent = ({
  recipient,
  companyName,
}: RecipientPopoverContentProps) => (
  <div>
    <Typography.Text className='font-semibold block'>{recipient.name}</Typography.Text>
    <Typography.Text>
      {recipient.bio ??
        (recipient.isPartner ? (
          <FormattedMessage
            message={sharedMessages.partnerBio}
            values={{ name: companyName ?? '' }}
          />
        ) : (
          <FormattedMessage message={sharedMessages.bio} values={{ name: companyName ?? '' }} />
        ))}
    </Typography.Text>
  </div>
)
